import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../AuthContext";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import API from "../../Authentification/api";
import Button from "react-bootstrap/Button";
import "../../../Styles/Styles.css";
import telephone from "../../assets/Images/icone/appel-telephonique.png";
import Logo from "../../assets/Images/Logo_entreprise-removebg-preview.webp";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import DehazeOutlinedIcon from '@mui/icons-material/DehazeOutlined';


// Import dropdown moderne

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CloseIcon from '@mui/icons-material/Close';

const Navbar1 = () => {
  const [active, setActive] = useState("");
  const { isLoggedIn } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await API.post("/logout");
      localStorage.removeItem("token");
      toast.success("Déconnexion réussie");
      navigate("/login");
    } catch (err) {
      toast.error("Erreur lors de la déconnexion");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const navLinks = [
    { to: "/", icon: <HomeOutlinedIcon />, label: "Accueil" },
    { to: "/About", icon: <InfoOutlinedIcon />, label: "À propos" },
    { to: "", icon: <MiscellaneousServicesOutlinedIcon />, label: "Services" },
    { to: "/cart", icon: <ShoppingCartOutlinedIcon />, label: "Achat" },
    { to: "/products", icon: <StorefrontOutlinedIcon />, label: "Produits" },
    { to: "/aide&Faq", icon: <HelpOutlineOutlinedIcon />, label: "FAQ & aide" },
    { to: "/Contact", icon: <ContactMailOutlinedIcon />, label: "Contact" },
  ];

  return (
    <div className="bg-light shadow-sm d-flex align-items-center navbar navbar-expand-lg w-100">
      <div className="container-fluid">
        <div className="tel col-12 col-lg-5 d-sm-block">
          <div className="row">

            {/* Desktop — bloc téléphone */}
            <div className="d-none d-lg-flex align-items-center flex-shrink-0" style={{ minWidth: 0 }}>
              <img src={telephone} alt="Appel" style={{ width: "28px", flexShrink: 0 }} />
              <h6 className="fw-semibold mb-0 ms-2 text-nowrap" style={{ fontSize: "clamp(11px, 1.1vw, 14px)" }}>
                Appelez-nous : (+229) 01 65 00 29 29
              </h6>
            </div>
            {/* ── MOBILE NAVBAR ── */}
            <nav className="mobile-navbar d-lg-none">
              <Link to="/">
                <img src={Logo} alt="logo" style={{ height: "38px" }} />
              </Link>

              <div className="nav-actions">
                <button className="icon-btn" onClick={handleOpen} aria-label="Compte">
                  <AccountCircleOutlinedIcon sx={{ fontSize: 22 }} />
                </button>

                <Menu
                  anchorEl={anchorEl} open={open}
                  onClose={handleClose} onClick={handleClose}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      mt: 1.5, minWidth: 200,
                      borderRadius: "14px",
                      border: "0.5px solid #e0ddd6",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
                      px: 0.5, py: 0.5,
                    },
                  }}
                >
                  {!isLoggedIn ? (
                    <>
                      <MenuItem component={Link} to="/login"
                        sx={{ borderRadius: "10px", py: 1.2, px: 1.5, gap: 1.5, fontSize: "14px", fontWeight: 500, "&:hover": { background: "#f5f2ed" } }}>
                        <ListItemIcon sx={{ minWidth: "unset" }}>
                          <LoginOutlinedIcon fontSize="small" sx={{ color: "#555" }} />
                        </ListItemIcon>
                        Connexion
                      </MenuItem>
                      <MenuItem component={Link} to="/register"
                        sx={{ borderRadius: "10px", py: 1.2, px: 1.5, gap: 1.5, fontSize: "14px", fontWeight: 500, "&:hover": { background: "#f5f2ed" } }}>
                        <ListItemIcon sx={{ minWidth: "unset" }}>
                          <PersonAddAltOutlinedIcon fontSize="small" sx={{ color: "#555" }} />
                        </ListItemIcon>
                        Créer un compte
                      </MenuItem>
                    </>
                  ) : (
                    <>
                      <MenuItem component={Link} to="/user"
                        sx={{ borderRadius: "10px", py: 1.2, px: 1.5, gap: 1.5, fontSize: "14px", fontWeight: 500, "&:hover": { background: "#f5f2ed" } }}>
                        <ListItemIcon sx={{ minWidth: "unset" }}>
                          <PersonOutlineOutlinedIcon fontSize="small" sx={{ color: "#555" }} />
                        </ListItemIcon>
                        Mon compte
                      </MenuItem>
                      <Divider sx={{ my: 0.5, borderColor: "#f0ede8" }} />
                      <MenuItem onClick={logout}
                        sx={{ borderRadius: "10px", py: 1.2, px: 1.5, gap: 1.5, fontSize: "14px", fontWeight: 500, color: "#c0392b", "&:hover": { background: "#fdf0ee" } }}>
                        <ListItemIcon sx={{ minWidth: "unset" }}>
                          <LogoutOutlinedIcon fontSize="small" sx={{ color: "#c0392b" }} />
                        </ListItemIcon>
                        Déconnexion
                      </MenuItem>
                    </>
                  )}
                </Menu>

                <Link to={isLoggedIn ? "/user/favoris" : "/login"} className="icon-btn" style={{ color: "inherit" }}>
                  <FavoriteBorderIcon sx={{ fontSize: 22 }} />
                </Link>

                {/* Hamburger */}
                <button
                  className={`hamburger-btn ${isOpen ? "open" : ""}`}
                  onClick={() => setIsOpen(!isOpen)}
                  aria-label="Menu"
                >
                  <span className="bar bar-top" />
                  <span className="bar bar-mid" />
                  <span className="bar bar-bot" />
                </button>
              </div>
            </nav>

            {/* ── DRAWER (sans overlay) ── */}
            <div className={`mobile-drawer ${isOpen ? "open" : ""}`}>

              {/* Header */}
              <div className="drawer-header">
                <img src={Logo} alt="logo" style={{ height: "36px" }} />
                <button className="drawer-close" onClick={() => setIsOpen(false)}>
                  <CloseIcon style={{ fontSize: 18 }} />  {/* importe CloseIcon de MUI */}
                </button>
              </div>

              {/* Label section */}
              <p className="drawer-section-label">Navigation</p>

              {/* Links */}
              <nav className="drawer-nav">
                {navLinks.map(({ to, icon, label }) => (
                  <Link
                    key={label}
                    to={to}
                    className="drawer-link"
                    onClick={() => setIsOpen(false)}
                  >
                    <span className="drawer-link-left">
                      {icon}
                      {label}
                    </span>
                    <span className="drawer-arrow">›</span>
                  </Link>
                ))}
              </nav>

              {/* Footer */}
              <div className="drawer-footer">
                <Link to="/all_products" className="drawer-cta" onClick={() => setIsOpen(false)}>
                  Acheter maintenant
                </Link>
              </div>

            </div>

          </div>
        </div>

        {/* Desktop links */}
        <div className="d-none d-lg-flex align-items-center gap-3 flex-shrink-0 ms-auto">
          <h6 className="fw-semibold nav-item mb-0">
            <Link to="/Contact" className="fw-bold text-decoration-none petit_titre"
              style={{ color: active === "Contact" ? "orange" : "black" }}
              onClick={() => setActive("Contact")}>Contactez-nous</Link>
          </h6>
          <h6 className="fw-semibold nav-item mb-0">
            <Link to="/About" className="fw-bold text-decoration-none petit_titre"
              style={{ color: active === "About" ? "orange" : "black" }}
              onClick={() => setActive("About")}>À propos</Link>
          </h6>
          <Button as={Link} to="/all_products" type="button" className="rounded-5 border-0 premium-btn text-nowrap">
            Acheter maintenant
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Navbar1;
